// extracted by mini-css-extract-plugin
module.exports = {"container":"NetworkFollowers_container__3PbHe"};